// extracted by mini-css-extract-plugin
export default {"widget__title":"Widget_widget__title__BobWs","widget__subtitle":"Widget_widget__subtitle__tChfB","AccordionSummary":"Widget_AccordionSummary__liA+a"};